import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import SuggestionRenderer from '../../FiltersField/renderers/SuggestionRenderer';
import { profile as profileApi } from '@afosto/iam/api/Profile';

const ORDER_TAGS_PATH = 'afosto.tenant.odr.orders.tags';

const OrderTagsRenderer = ({ value, ...props }) => {
  const [formattedTags, setFormattedTags] = useState([]);

  useEffect(() => {
    let isMounted = true;
    const handleFetchProfile = async () => {
      try {
        const { data = [] } = await profileApi.getProfile(ORDER_TAGS_PATH);

        const formattedData = data.filter(tag => value.includes(tag?.code));
        if (isMounted) {
          setFormattedTags(formattedData);
        }
      } catch (error) {
        if (isMounted) {
          setFormattedTags(null);
        }
      }
    };

    if (isMounted && value?.length > 0) {
      handleFetchProfile();
    }

    return () => {
      isMounted = false;
    };
  }, [value]);

  const formattedValue = formattedTags?.map(tag => tag?.label);

  return <SuggestionRenderer {...props} value={formattedValue} />;
};

OrderTagsRenderer.propTypes = {
  value: PropTypes.array,
};

OrderTagsRenderer.defaultProps = {
  value: [],
};

export default OrderTagsRenderer;
